import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-add-edit-counselling-highlights',
  templateUrl: './add-edit-counselling-highlights.component.html',
  styleUrls: ['./add-edit-counselling-highlights.component.scss']
})
export class AddEditCounsellingHighlightsComponent implements OnInit {
  highlightForm!: FormGroup;

  centres = [
    'AL Borivali', 'AL Andheri', 'AL Thane', 'AL Bangalore', 'AL Delhi'
  ];

  children = [
    'Child 1', 'Child 2', 'Child 3'
  ];

  relations = [
    'Mother', 'Father', 'Grandparents', 'Siblings', 'Uncle', 'Aunt'
  ];

  challenges = [
    'Emotional Issue', 'Behaviour Issue', 'Family Issue', 'Peer Issue'
  ];

  sessionTypes = [
    'All', 'Starred'
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.buildSingleForm();
  }

  buildSingleForm() {
    this.highlightForm = this.fb.group({

      // CAREGIVERS
      caregiver: this.fb.group({
        centreName: [''],
        childName: [''],
        dateRange: [''],
        sessionType: [''],
        relation: [''],
        challenges: [''],
        remarks: ['']
      }),

      // TEENS
      teen: this.fb.group({
        centreName: [''],
        childName: [''],
        dateRange: [''],
        sessionType: [''],
        challenges: [''],
        remarks: ['']
      }),

      // CHILD
      child: this.fb.group({
        centreName: [''],
        childName: [''],
        dateRange: [''],
        sessionType: [''],
        challenges: [''],
        remarks: ['']
      })
    });
  }

  submit() {
    console.log("FINAL DATA:", this.highlightForm.value);
  }

}
